import jquery from "jquery"
import SuperSelectController from "./super_select_controller"

export default class extends SuperSelectController {
  formatPreviewState(option) {
    const data = option.element?.dataset
    if (!data?.select2JobPreviewName) {
      return super.formatPreviewState(option)
    }

    const preview = document.createElement("div")
    preview.className = "inline-tail min-w-0 py-1 leading-4"
    preview.dataset.controller = "inline-tail"
    preview.dataset.inlineTailPolicyValue = "block"
    preview.dataset.select2OptionLabel = data.select2JobPreviewName

    const lead = this.appendTextElement(
      preview,
      "span",
      "font-medium text-slate-900 dark:text-white",
      data.select2JobPreviewName
    )
    lead.dataset.inlineTailRole = "lead"

    this.appendJobPreviewUnit(preview, data.select2JobPreviewTimeline, "fal fa-calendar")
    this.appendJobPreviewUnit(
      preview,
      data.select2JobPreviewStaffing,
      "fal fa-users",
      this.staffingClassName(data.select2JobPreviewStaffingStatus)
    )
    this.appendJobPreviewUnit(preview, data.select2JobPreviewPeople, "fal fa-user-group")

    return jquery(preview)
  }

  formatSelection(data, container) {
    const jobName = data.element?.dataset?.select2JobPreviewName
    if (!jobName) {
      return super.formatSelection(data, container)
    }

    const selection = document.createElement("span")
    selection.textContent = jobName
    return jquery(selection)
  }

  appendJobPreviewUnit(parent, text, iconClassName, className = "text-slate-500 dark:text-slate-300") {
    if (!text) return null

    const unit = document.createElement("span")
    unit.className = `text-xs leading-4 ${className}`
    unit.dataset.inlineTailRole = "unit"

    const separator = this.appendTextElement(unit, "span", "leading-none", "·")
    separator.dataset.inlineTailRole = "separator"
    separator.setAttribute("aria-hidden", "true")

    const content = document.createElement("span")
    content.className = "min-w-0 break-words whitespace-normal"
    content.dataset.inlineTailRole = "content"

    const icon = document.createElement("i")
    icon.className = `mr-1 inline-block ${iconClassName}`
    icon.setAttribute("aria-hidden", "true")
    content.appendChild(icon)
    content.appendChild(document.createTextNode(text))

    unit.appendChild(content)
    parent.appendChild(unit)
    return unit
  }

  staffingClassName(status) {
    if (status === "open") return "text-amber-600 dark:text-amber-300"
    if (status === "filled") return "text-emerald-600 dark:text-emerald-300"

    return "text-slate-500 dark:text-slate-300"
  }
}
